<template>
  <div class="input-group">
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-text-field
          v-model="node.name"
          label="Name"
          hide-details
          @keyup.down="pressDown"
          @keyup.up="pressUp"
          @keydown.enter="onEnter"
          @keydown.tab="pressTab"
        >
        </v-text-field>
        <!-- === use for Intellisense ===-->
        <intellisense-component
          :input="node.name"
          :drawFlowItems="drawFlowItems"
          :property="'name'"
          :apiForIntellisense="apiForIntellisense"
          :start="start"
          :eventKey="eventKey"
          @clearSelected="clearSelected"
          @updateInputFromIntellisense="updateInputFromIntellisense"
        />
        <!-- === use for Intellisense ===-->
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-textarea
          class="textarea-input overflow-x"
          solo
          hide-details
          rows="7"
          v-model="property.message"
          placeholder="Enter log here ..."
          @keyup.down="pressDown"
          @keyup.up="pressUp"
          @keydown.enter="onEnter"
          @keydown.tab="pressTab"
        ></v-textarea>
        <!-- === use for Intellisense ===-->
        <intellisense-component
          :input="property.message"
          :drawFlowItems="drawFlowItems"
          :property="'message'"
          :apiForIntellisense="apiForIntellisense"
          :start="start"
          :eventKey="eventKey"
          @clearSelected="clearSelected"
          @updateInputFromIntellisense="updateInputFromIntellisense"
        />
        <!-- === use for Intellisense ===-->
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-select
          class="m-auto"
          v-model="property.log_level"
          :items="logLevel"
          item-text="label"
          item-value="value"
          label="Log level"
          dense
          hide-details
        ></v-select>
      </v-col>
    </v-row>
    <!-- =========== ปุ่ม sendNotification =========== -->
    <div class="m-t-15">
      <v-switch
        v-model="property.send_notification"
        label="Send notification"
        inset
        dense
        x-small
        hide-details
      ></v-switch>
      <!-- เช็คว่าปุ่ม  toggle เปิดไหม ถ้าเปิด จะ show UI ส่ง API -->
      <div v-if="property.send_notification">
        <!-- ========== API ===================== -->
        <v-row>
          <v-col>
            <v-select
              v-model="property.api.methods"
              class="width150px"
              :items="methods"
              label="Method"
              dense
              hide-details
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              v-model="property.api.url"
              label="URL"
              hide-details
              dense
              @keyup.down="pressDown"
              @keyup.up="pressUp"
              @keydown.enter="onEnter"
              @keydown.tab="pressTab"
            >
            </v-text-field>
            <!-- === use for Intellisense  ===-->
            <intellisense-component
              :input="property.api.url"
              :drawFlowItems="drawFlowItems"
              :property="'url'"
              :apiForIntellisense="apiForIntellisense"
              :start="start"
              :eventKey="eventKey"
              @clearSelected="clearSelected"
              @updateInputFromIntellisense="updateInputFromIntellisense"
            />
            <!-- === use for Intellisense ===-->
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12" lg="12" class="m-t-10 pt-0 pb-0">
            <v-tabs centered fixed-tabs v-model="activeTab">
              <v-tab
                v-for="item in itemsTab"
                :id="item"
                :key="item"
                class="font-size-sub"
                @click="currentTab = item"
              >
                {{ item }}
              </v-tab>
            </v-tabs>
          </v-col>
          <v-col
            v-if="currentTab === 'headers'"
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <fieldset class="form-group m-b-0 height200px">
              <v-row>
                <v-col cols="12" sm="5" lg="5">
                  <span>Key</span>
                </v-col>
                <v-col
                  cols="12"
                  sm="7"
                  lg="7"
                  class="d-flex justify-space-between"
                >
                  <span>Value</span>
                  <v-icon small @click="addHeader">fa-plus-circle</v-icon>
                </v-col>
              </v-row>

              <v-row v-for="(pair, index) in property.api.headers" :key="index">
                <v-col cols="12" sm="5" lg="5" class="p-t-0">
                  <v-text-field
                    class="margin0 padding0"
                    v-model="property.api.headers[index].key"
                    hide-details
                    dense
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  sm="7"
                  lg="7"
                  class="p-t-0 d-flex justify-space-between"
                >
                  <v-text-field
                    class="margin0 padding0"
                    v-model="property.api.headers[index].value"
                    hide-details
                    dense
                  ></v-text-field>
                  <v-icon small class="ml-1" @click="deleteHeader(index)"
                    >fa-trash</v-icon
                  >
                </v-col>
              </v-row>
            </fieldset>
          </v-col>
          <v-col v-if="currentTab === 'body'" cols="12" sm="12" md="12" lg="12">
            <v-textarea
              class="textarea-input overflow-x"
              solo
              hide-details
              rows="7"
              v-model="property.api.body"
              @keyup.down="pressDown"
              @keyup.up="pressUp"
              @keydown.enter="onEnter"
              @keydown.tab="pressTab"
            ></v-textarea>
            <!-- === use for Intellisense ===-->
            <intellisense-component
              :input="property.api.body"
              :drawFlowItems="drawFlowItems"
              :property="'body'"
              :apiForIntellisense="apiForIntellisense"
              :start="start"
              :eventKey="eventKey"
              @clearSelected="clearSelected"
              @updateInputFromIntellisense="updateInputFromIntellisense"
            />
            <!-- === use for Intellisense ===-->
          </v-col>
          <v-col
            v-if="currentTab === 'settings'"
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <fieldset class="form-group m-b-0 height200px">
              <v-row class="align-center">
                <v-col class="p-b-0" cols="12" sm="6" lg="6">
                  <span>Request timeout</span>
                </v-col>
                <v-col
                  class="middle d-flex align-center p-b-0"
                  cols="12"
                  sm="6"
                  lg="6"
                >
                  <div>
                    <v-text-field
                      class="margin0 padding0 width70px"
                      v-model="property.api.setting.timeout"
                      type="number"
                      @blur="setPropertyData('timeout')"
                      hide-details
                      dense
                      reverse
                    ></v-text-field>
                  </div>
                  <div class="ml-2">seconds</div>
                </v-col>
              </v-row>
              <v-row class="align-center">
                <v-col class="p-b-0" cols="12" sm="6" lg="6">
                  <span>Wait for response</span>
                </v-col>
                <v-col
                  class="middle d-flex align-center p-b-0"
                  cols="12"
                  sm="6"
                  lg="6"
                >
                  <div class="width70px">
                    <v-switch
                      class="margin-left"
                      v-model="property.api.setting.await"
                      inset
                      dense
                      hide-details
                    ></v-switch>
                  </div>
                </v-col>
              </v-row>
            </fieldset>
          </v-col>
        </v-row>
      </div>
    </div>
    <!-- =========== ปุ่ม sendNotification =========== -->

    <hr class="note-divider" />
    <note-component :node="node" />
  </div>
</template>

<script>
import NoteComponent from '../../../components/note'
// === use for Intellisense ===
import IntellisenseComponent from '../../../components/intellisense'
// === use for Intellisense ===
export default {
  props: {
    node: Object,
    // === use for Intellisense ===
    drawFlowItems: Object,
    apiForIntellisense: Object
    // === use for Intellisense ===
  },
  components: {
    NoteComponent,
    // === use for Intellisense ===
    IntellisenseComponent
    // === use for Intellisense ===
  },
  watch: {
    // 'property.message': {
    //   handler(value) {
    //     this.node.name = value
    //   }
    // }
  },
  data() {
    return {
      property: {},
      // === use for Intellisense ===
      start: -1,
      isKeyTab: false,
      eventKey: '',
      // === use for Intellisense ===
      logLevel: [
        // { label: 'Emerg', value: 'emerg' },
        // { label: 'Alert', value: 'alert' },
        // { label: 'Crit', value: 'crit' },
        { label: 'Error', value: 'error' },
        { label: 'Warning', value: 'warning' },
        // { label: 'Notice', value: 'notice' },
        { label: 'Info', value: 'info' },
        { label: 'Debug', value: 'debug' }
      ],
      //-------- api --------
      methods: ['GET', 'PUT', 'POST', 'DELETE'],
      itemsTab: [],
      currentTab: 'body',
      activeTab: 1
    }
  },
  created() {
    this.property = this.node.property
    //-------- api --------
    setTimeout(() => {
      this.itemsTab = ['headers', 'body', 'settings']
    }, 500)
  },
  // === use for Intellisense ให้ keyup keyDown ได้ ===
  methods: {
    pressDown() {
      this.start += 1
      this.eventKey = 'keydown'
    },
    pressUp() {
      this.start -= 1
      this.eventKey = 'keyup'
    },
    pressTab() {
      this.isKeyTab = true
      this.start = -1
    },
    onEnter() {
      this.start = -1
      this.eventKey = 'enter'
    },
    clearSelected() {
      this.start = -1
    },
    updateInputFromIntellisense(property, data) {
      if (property == 'message') {
        this.property.message = data
      } else if (property == 'name') {
        this.node.name = data
      } else if (property == 'url') {
        this.property.api.url = data
      } else if (property == 'body') {
        this.property.api.body = data
      }
    },
    //-------- api --------
    setPropertyData(property) {
      const numberPattern = /^\d+$/
      let val = 30.0
      if (!numberPattern.test(this.property.api.setting[property])) {
        val = this.lastValueSettingTimeout
        this.property.api.setting[property] = parseFloat(val).toFixed(1)
      } else {
        val = this.property.setting[property]

        if (val < 0) {
          val = 0
        }
        this.property.api.setting[property] = parseFloat(val).toFixed(1)
        this.lastValueSettingTimeout = this.property.setting[property]
      }
    },
    addHeader() {
      this.property.api.headers.push({
        key: '',
        value: ''
      })
    },
    deleteHeader(index) {
      this.property.api.headers.splice(index, 1)
    }
    //-------- api --------
  }
  // === use for Intellisense ให้ keyup keyDown ได้ ===
}
</script>

<style scoped lang="scss">
.width70px {
  width: 70px;
}
.margin-left {
  margin-left: 30px !important;
}
.height200px {
  min-height: 222px;
  overflow-y: auto;
}

::v-deep .v-slide-group {
  height: 30px !important;
}

::v-deep .v-slide-group__prev,
::v-deep .v-slide-group__next {
  display: none;
}

.textarea-input {
  font-size: 14px;
}
</style>
